import { RootState } from 'store';

export const bicStateSelector = (state: RootState): string => state.bic.bic;
export const bicErrorSelector = (state: RootState): boolean => state.bic.bicError;
export const bicRequiredErrorSelector = (state: RootState): boolean => state.bic.bicRequiredError;

export const bicLoadingSelector = (state: RootState): boolean => state.bic.loading;
